<template>
  <v-select
    v-model="selectedTags"
    :label="label"
    :placeholder="placeholder"
    :items="tagsList"
    item-value="tagID"
    item-text="tagName"
    chips
    clearable
    color="bluecolor"
    item-color="bluecolor"
    multiple
    prepend-icon="mdi-label-multiple-outline"
    sort-desc
    @change="$emit('set-tags', selectedTags)"
  >
    <!-- Affichage des sélections possibles -->
    <template v-slot:item="{ attrs, item, on }">
      <v-list-item
        v-bind="attrs"
        active-class="bluecolor elevation-4 white--text"
        class="mx-3 mb-2 v-sheet"
        elevation="0"
        v-on="on"
      >
        <v-list-item-content>
          <v-list-item-title
            v-text="item.tagName"
          />
        </v-list-item-content>

        <v-scale-transition>
          <v-list-item-icon
            v-if="attrs.inputValue"
            class="my-3"
          >
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
        </v-scale-transition>
      </v-list-item>
    </template>

    <!-- Affichage des labels sélectionnés -->
    <template v-slot:selection="{ attrs, item, select, selected }">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        close
        close-icon="mdi-close"
        label
        outlined
        color="bluecolor"
        @click="select"
        @click:close="remove(item)"
      >
        <strong>{{ item.tagName }}</strong>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'TagsFilter',

    /* Paramètres */
    props: {
      idCompany: {
        type: String,
        default: undefined,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      companyList: {
        type: Array,
        default: undefined,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        label: 'Equipe(s) sélectionnée(s) pour affiner votre vue',
        placeholder: 'Toute l\'entreprise',
        tagsList: [],
        selectedTags: [],
      }
    },

    computed: {
      // Création de la requête
      getRequest: function () {
        let res = (this.idCompany ? '?companyId=' + this.idCompany : '')
        if (this.companyList && this.companyList.length > 0) {
          this.companyList.forEach(company => {
            res.length
              ? (res = res + '&companyList[]=' + company)
              : (res = res + '?companyList[]=' + company)
          })
        }
        if (this.$Auth.isAdmin()) {
          res.length
            ? (res = res + '&adminView')
            : (res = res + '?adminView')
        }
        return res
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      idCompany: function () {
        this.fetchTags()
      },
      companyList: function () {
        this.fetchTags()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchTags()
    },

    /* Fonctions internes */
    methods: {
      fetchTags: function () {
        this.$Auth.httpRequest(
          'get',
          'api/dashboard/selectTagsByCompanyId' + this.getRequest,
        )
          .then((response) => {
            if (Array.isArray(response.data) || response.data.length > 0) {
              this.tagsList = response.data
            } else {
              this.tagsList = []
            }
          })
          .catch((/* error */) => {
            this.tagsList = []
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
      },

      remove: function (item) {
        this.selectedTags.splice(this.selectedTags.indexOf(item), 1)
        this.selectedTags = [...this.selectedTags]
      },
    },

  }
</script>
